export const IMMEDIATE_INPUT_TYPES = ['checkbox', 'radio'];

export const BLUR_RELEASE_DELAY_MS = 150;
